import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = {
  class: "fw-bolder d-flex align-items-center fs-5",
  style: {"text-transform":"capitalize"}
}
const _hoisted_6 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_8 = { class: "menu-item px-5" }
const _hoisted_9 = { class: "menu-text" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_12 = { class: "menu-link px-5" }
const _hoisted_13 = { class: "menu-title position-relative" }
const _hoisted_14 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_15 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg"
  })
], -1)
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/spain.svg"
  })
], -1)
const _hoisted_20 = { class: "menu-item px-5 my-1" }
const _hoisted_21 = { class: "menu-item px-5 my-1" }
const _hoisted_22 = { class: "menu-item px-5" }
const _hoisted_23 = {
  class: "menu-link px-5",
  "data-bs-toggle": "modal",
  "data-bs-target": "#support_modal"
}
const _hoisted_24 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SupportForm = _resolveComponent("SupportForm")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.authenticatedUser.name) + " " + _toDisplayString(_ctx.authenticatedUser.lastname), 1),
            _createVNode("a", _hoisted_6, _toDisplayString(_ctx.authenticatedUser.email), 1)
          ])
        ])
      ]),
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/dashboard",
          class: "menu-link px-5"
        }, {
          default: _withCtx(() => [
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.translate("myOrganizations")), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_10,
      _createVNode("div", _hoisted_11, [
        _createVNode("span", _hoisted_12, [
          _createVNode("span", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.translate("language")) + " ", 1),
            _createVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
              _createVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, ["src"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
              href: "#",
              class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }]
            }, [
              _hoisted_17,
              _createTextVNode(" " + _toDisplayString(_ctx.translate("english")), 1)
            ], 2)
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('es'))),
              href: "#",
              class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('es') }]
            }, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.translate("spanish")), 1)
            ], 2)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode(_component_router_link, {
          to: {
              path: '/crafted/account/user-account',
              query: { path: _ctx.$route.fullPath }
            },
          class: "menu-link px-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.translate("myAccount")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, {
          to: "/crafted/account/user-password",
          class: "menu-link px-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.translate("passwordReset")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("a", _hoisted_23, _toDisplayString(_ctx.translate("support")), 1)
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode("a", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signOut())),
          class: "menu-link px-5"
        }, _toDisplayString(_ctx.translate("turnOff")), 1)
      ])
    ]),
    _createVNode(_component_SupportForm)
  ], 64))
}